module.exports = __webpack_public_path__ + "img/front_length_to_waist.f3175a2f.png";